import { render } from "./SearchClientModal.vue?vue&type=template&id=51cf7050&scoped=true"
import script from "./SearchClientModal.vue?vue&type=script&lang=js"
export * from "./SearchClientModal.vue?vue&type=script&lang=js"

import "./SearchClientModal.vue?vue&type=style&index=0&id=51cf7050&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51cf7050"]])

export default __exports__